module.exports = __webpack_public_path__ + "img/floatright22.d39233a3.jpg";